enum PhysicalSampleState {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    UNKNOWN = 'UNKNOWN',
}

export default PhysicalSampleState;
